import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getAlert = state => getStateSlice(state).get('alert');

export const getIsOpen = state => getStateSlice(state).get('isOpen');
